/* セールページの共通スクリプト。
   カウントダウンと、カテゴリカードによる絞り込み・並び替えを受け持つ。

   商品はページ内に全件そろえてから、ブラウザ側で絞り込みと並び替えをする。
   最初の50件はサーバー側で描かれており、51件目以降は
   /collections/<handle>?view=mdl-sale-grid&page=N で足す。
   （このストアでは /collections/<handle>/<tag> のタグ絞り込み URL が
   効かないため、タグはカードが持つ data-tags で判定する） */
(function () {
  'use strict';

  var PAGE_SIZE = 50;

  /* ── カウントダウン ─────────────────────────── */
  function initCountdown(box) {
    if (box.dataset.mdlSaleReady === '1') return;
    box.dataset.mdlSaleReady = '1';

    var timeEl = box.querySelector('[data-cd-time]');
    var labelEl = box.querySelector('[data-cd-label]');
    var end = new Date(box.dataset.end).getTime();
    var hideAfterEnd = box.dataset.afterEnd !== 'message';
    if (!timeEl || isNaN(end)) return;

    var timer = setInterval(tick, 1000);
    tick();

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        clearInterval(timer);
        if (hideAfterEnd) {
          box.hidden = true;
          return;
        }
        timeEl.textContent = box.dataset.endMessage || 'セールは終了しました';
        if (labelEl) labelEl.textContent = box.dataset.endLabel || 'ご利用ありがとうございました';
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      timeEl.textContent = d + '日 ' + h + '時間 ' + m + '分 ' + (s % 60) + '秒';
    }
  }

  /* ── 商品一覧 ───────────────────────────────── */
  function initShop(root) {
    if (root.dataset.mdlSaleReady === '1') return;
    root.dataset.mdlSaleReady = '1';

    var list = root.querySelector('[data-sale-list]');
    var countEl = root.querySelector('[data-sale-count]');
    var titleEl = root.querySelector('[data-sale-title]');
    var emptyEl = root.querySelector('[data-sale-empty]');
    var moreBtn = root.querySelector('[data-sale-more]');
    var bar = root.querySelector('[data-sale-filterbar]');
    var barLabel = root.querySelector('[data-sale-filter-label]');
    var clearBtn = root.querySelector('[data-sale-filter-clear]');
    var cards = [].slice.call(root.querySelectorAll('[data-sale-card]'));
    var sortBtns = [].slice.call(root.querySelectorAll('[data-sort]'));
    if (!list) return;

    var handle = root.dataset.collection || '';
    var total = parseInt(root.dataset.total || '0', 10) || 0;
    var pageSize = parseInt(root.dataset.limit || '24', 10) || 24;
    var wantRank = root.dataset.rank === '1';
    var wantReview = root.dataset.review === '1';
    // 「もっと見る」を出さないときは件数で切らず、該当分をすべて並べる
    var useMore = root.dataset.showMore !== '0';
    // 絞り込み中の「人気順」をレビュー件数の多い順にするか
    var filteredSort = root.dataset.filteredSort || 'reviews';
    var headingRank = root.dataset.headingRank || '';
    var headingFiltered = root.dataset.headingFiltered || '';

    var items = [].slice.call(list.querySelectorAll('.item'));
    var state = { sort: 'rank', tag: '', label: '', shown: useMore ? pageSize : Infinity };
    // 初期の絞り込みは「既定の表示」として扱い、絞り込み中の表示は出さない
    var atDefault = false;

    if (!wantReview) stripReviews(list);
    applyDefaultCard();
    render();
    loadRest();

    // 最初から押した状態にするカードがあれば、その絞り込みで開く
    function applyDefaultCard() {
      var preset = null;
      cards.forEach(function (c) {
        if (!preset && c.dataset.default === '1' && (c.dataset.tag || '').trim()) preset = c;
      });
      if (!preset) return;
      state.tag = (preset.dataset.tag || '').trim();
      state.label = preset.dataset.label || '';
      preset.setAttribute('aria-pressed', 'true');
      atDefault = true;
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        atDefault = false;
        var tag = (card.dataset.tag || '').trim();
        if (!tag) {
          // タグを持たないカードは絞り込まず、一覧の先頭へ送るだけ
          clearFilter();
          scrollToList();
          return;
        }
        var same = state.tag === tag;
        state.tag = same ? '' : tag;
        state.label = same ? '' : (card.dataset.label || '');
        cards.forEach(function (c) {
          c.setAttribute('aria-pressed', c === card && !same ? 'true' : 'false');
        });
        state.shown = useMore ? pageSize : Infinity;
        render();
        scrollToList();
      });
    });

    sortBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (state.sort === btn.dataset.sort) return;
        state.sort = btn.dataset.sort;
        sortBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        state.shown = useMore ? pageSize : Infinity;
        render();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        atDefault = false;
        clearFilter();
        render();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.shown += pageSize;
        render();
      });
    }

    function clearFilter() {
      state.tag = '';
      state.label = '';
      state.shown = useMore ? pageSize : Infinity;
      cards.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
    }

    /* 51件目以降をページ単位で足す。取れた分だけ順に反映する */
    function loadRest() {
      if (!handle || total <= PAGE_SIZE) return;
      var pages = Math.ceil(total / PAGE_SIZE);
      var next = 2;

      (function step() {
        if (next > pages) return;
        var page = next++;
        fetch('/collections/' + encodeURIComponent(handle) + '?view=mdl-sale-grid&page=' + page)
          .then(function (res) { return res.ok ? res.text() : Promise.reject(new Error('HTTP ' + res.status)); })
          .then(function (html) {
            var holder = document.createElement('div');
            holder.innerHTML = html;
            var added = [].slice.call(holder.querySelectorAll('.item'));
            if (!added.length) return;
            added.forEach(function (el) {
              if (!wantReview) stripReviews(el);
              list.appendChild(el);
              items.push(el);
            });
            render();
          })
          .catch(function () { /* 取れなかったページは諦め、取れている分で続ける */ })
          .then(step);
      })();
    }

    function matches(el) {
      if (!state.tag) return true;
      var tags = el.dataset.tags || '';
      return state.tag.split(',').every(function (t) {
        var name = t.trim();
        return !name || tags.indexOf(',' + name + ',') !== -1;
      });
    }

    function render() {
      var visible = items.filter(matches);

      visible.sort(function (a, b) {
        if (state.sort === 'rank') {
          if (state.tag && filteredSort === 'reviews') {
            // レビュー件数が同じものは、コレクションの並び順で決める
            var r = (+b.dataset.reviews || 0) - (+a.dataset.reviews || 0);
            if (r !== 0) return r;
          }
          return (+a.dataset.order || 0) - (+b.dataset.order || 0);
        }
        var d = (+a.dataset.price || 0) - (+b.dataset.price || 0);
        return state.sort === 'asc' ? d : -d;
      });

      var showRank = wantRank && state.sort === 'rank' && !state.tag;

      items.forEach(function (el) { el.hidden = true; });
      visible.slice(0, state.shown).forEach(function (el, i) {
        el.hidden = false;
        list.appendChild(el);
        var badge = el.querySelector('[data-rank]');
        if (badge) {
          badge.hidden = !showRank;
          badge.textContent = 'No. ' + (i + 1);
          badge.className = 'rank' + (i < 3 ? ' rank-' + (i + 1) : '');
        }
      });

      list.classList.toggle('no-rank', !showRank);
      if (titleEl) titleEl.textContent = showRank ? headingRank : headingFiltered;
      if (countEl) countEl.textContent = visible.length;
      if (emptyEl) emptyEl.hidden = visible.length !== 0;
      if (moreBtn) moreBtn.hidden = visible.length <= state.shown;
      syncFilterBar();
    }

    function stripReviews(scope) {
      [].slice.call(scope.querySelectorAll('.rate')).forEach(function (el) {
        el.parentNode.removeChild(el);
      });
    }

    function syncFilterBar() {
      if (!bar) return;
      var show = !!state.tag && !atDefault;
      bar.hidden = !show;
      bar.classList.toggle('on', show);
      if (barLabel) barLabel.textContent = state.label || state.tag;
    }

    function scrollToList() {
      (titleEl || list).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function initAll(scope) {
    var target = scope || document;
    [].slice.call(target.querySelectorAll('[data-mdl-sale-countdown]')).forEach(initCountdown);
    [].slice.call(target.querySelectorAll('[data-mdl-sale-shop]')).forEach(initShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // テーマエディタでセクションを編集すると中身が差し替わるため、都度初期化する
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
